/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTrashFilled = createReactComponent("trash-filled", "IconTrashFilled", [
  [
    "path",
    {
      d: "M20 6a1 1 0 0 1 .117 1.993l-.117 .007h-.081l-.919 11a3 3 0 0 1 -2.824 2.995l-.176 .005h-8c-1.598 0 -2.904 -1.249 -2.992 -2.75l-.005 -.167l-.923 -11.083h-.08a1 1 0 0 1 -.117 -1.993l.117 -.007h16z",
      fill: "currentColor",
      key: "svg-0",
      strokeWidth: "0"
    }
  ],
  [
    "path",
    {
      d: "M14 2a2 2 0 0 1 2 2a1 1 0 0 1 -1.993 .117l-.007 -.117h-4l-.007 .117a1 1 0 0 1 -1.993 -.117a2 2 0 0 1 1.85 -1.995l.15 -.005h4z",
      fill: "currentColor",
      key: "svg-1",
      strokeWidth: "0"
    }
  ]
]);

export { IconTrashFilled as default };
//# sourceMappingURL=IconTrashFilled.js.map
